import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Склейка классов для компонентов из shadcn.
 *
 * `clsx` убирает пустые и условные, `twMerge` разрешает спор одинаковых по
 * смыслу утилит: последняя побеждает. Без него `className="px-6"` снаружи не
 * перебил бы `px-3` варианта — обе строки остались бы в разметке, и выиграла
 * бы та, что стоит позже в собранном листе, а не та, что ближе к месту
 * применения.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
